import React, {useEffect, useState, useRef, Fragment} from "react";

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import moment from "moment";

// 共通部品
import {
	apollo_useStyles,
} from "../../atom/Apollo_styles";
import {
	apollo_zeus_delivery_type_budgets_path,
	zeus_ad_account,
} from "../../atom/Apollo_links";
import {
	AccountBudget,
	ZeusBudgetDetail,
	ZeusBudgets,
	RequestZeusBudgets,
} from "../../pages/BUDGET/BudgetModel";
import {
	ZeusAccountDetail,
} from "../../organism/ACCOUNT/AccountModel";

import {ApolloContext} from "../../atom/Apollo_Context";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import {ApolloMessage} from "../../atom/Apollo_Mesasge";
import ApolloTextNumberList, {PropsTextNumberList} from "../../atom/ACCOUNT/Apollo_TextNumberList";
import {optionsZeusDeliveryType} from "../../common/Apollo_CommonConst";
// メッセージ定義
import {
	GetMessage,
	UI_BUDGET_EDIT,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

// 操作ログ
import {ApolloEventRecord, LogData, ItemList} from "../../atom/Apollo_EventRecord";

export type PropsBudgetDeliveryType = {
	menuDisabled: boolean[]	// メニュー有効or無効
	menuAmount: number[]	// メニュー予算
	isAccountGroupAuth: boolean	// アカウントグループ認証情報
	budgetMonth1: string	// 当月
	budgetMonth2: string	// 翌月
	budgetMonth: string		// 選択月
	accountBudget?: AccountBudget	// アカウント月額予算情報
	zeusIsDisabled: boolean	// 無効化
	setIsDisabled: any	// 無効化セッター
	drawerState: any	// ドロワー状況
	setDrawerState: any	// ドロワー状況セッター
	history: any	// ヒストリー
	complete: boolean	// 準備完了
	read: boolean	// 再読み込み
	setRead: any	// 再読み込みセッター
	setDiffAmount: any	// Zeus配信種別予算合計差
	progress: boolean	// 初期表示状況
	resetAmount: boolean	// 予算額リセット
	setResetAmount: any	// 予算額リセットセッター
	changeAmount: boolean	// 予算更新
	setChangeAmount: any	// 予算更新セッター
	updateAvailability: boolean	// 変更ボタン有効化
	setUpdateAvailability: any	// 変更ボタン有効化セッター
	setMenuNames: any	// 変更メニュー名
}
interface BudgetDeliveryTypeProps {
	propsBudgetDeliveryType: PropsBudgetDeliveryType
};

// 
export default function ApolloBudgetDeliveryType(props: BudgetDeliveryTypeProps) {

	const {
		menuDisabled,
		menuAmount,
		isAccountGroupAuth,
		budgetMonth1,
		budgetMonth2,
		budgetMonth,
		accountBudget,
		zeusIsDisabled,
		setIsDisabled,
		drawerState,
		setDrawerState,
		history,
		complete,
		read,
		setRead,
		setDiffAmount,
		progress,
		resetAmount,
		setResetAmount,
		changeAmount,
		setChangeAmount,
		updateAvailability,
		setUpdateAvailability,
		setMenuNames,
	} = props.propsBudgetDeliveryType;

	const classes = apollo_useStyles();
	const {data, setmsg} = React.useContext(ApolloMessage);
	const {state} = React.useContext(ApolloContext);

	// パフォーマンス広告 キャンペーン種別別月額予算
	const [rtbListName, setRtbListName] = useState<string[]>(optionsZeusDeliveryType.map((option) => {return option.label}));
	const [rtbListDisabled, setRtbListDisabled] = useState<boolean>(false);
	const [zeusIsDisabledLocal, setZeusIsDisabledLocal] = useState(false);
	const [rtbListAmount, setRtbListAmount] = useState<number[]>();
	// 設定可能金額
	const [registerableAmount, setRegisterableAmount] = useState(0);
	// 旧予算額
	const [oldAmountList, setOldAmountList] = useState<number[][]>();
	// リセットボタンクリック有無
	const [reset, setReset] = useState(false);
	// 再読み込み
	const [reRead, setReRead] = useState(true);
	// 予算チェック結果
	const [checkResult, setCheckResult] = useState(false);
	// エラーメッセージ
	const [errorMenuLocal, setErrorMenuLocal] = useState<any>([]);
	// 予算変更ダイアログに表示する予算変更した配信種別名
	const deliveryNames = useRef("");
	// 操作前データ
	const beforeData = useRef<ZeusBudgets>();
	const resultApi = useRef(-1);
	const logTime = useRef("");
	const platformAccountId = useRef("");
	// Zeus配信種別別月額予算props作成
	var propsTextNumberListZeusWork:PropsTextNumberList[] = [];
	// Zeus配信種別別月額予算props引数
	optionsZeusDeliveryType.map((_, index) => {
		var workPropsTextNumberList:PropsTextNumberList = {
			label: rtbListName[index],
			setValue: setRtbListAmount,
			valueList: rtbListAmount ?? [0,0],
			index: index,
			value: rtbListAmount ? rtbListAmount[index] : 0,
			isDisabled: menuDisabled[0] || zeusIsDisabled || rtbListDisabled || !isAccountGroupAuth || zeusIsDisabledLocal || progress,
			required: false,
			message: errorMenuLocal,
			fieldName: "name" + index,
			minValue: 0,
			maxValue: menuAmount[0],
		}
		propsTextNumberListZeusWork.push(workPropsTextNumberList);
		return null;
	});

	// 予算入力Effect
	useEffect(() => {
		if (oldAmountList && rtbListAmount && rtbListAmount.length > 0 && complete) {
			if (reset) {
				setReset(false);
				return;
			}
			var idx = 1;
			if (budgetMonth === budgetMonth1) {
				idx = 0;
			}
			var valueTotal = 0;
			var disabled = true;
			// 予算変更ボタン活性化・非活性化
			rtbListAmount.map((amount, index) => {
				if (amount !== oldAmountList[idx][index]) {
					disabled = false;
				}
				valueTotal += amount;
				return null;
			});
			if (disabled) {
				// 変更なし
				// 予算入力状態初期化
				setIsDisabled(false);
				calcMenuAmountTotal(rtbListAmount, menuAmount[0]);
				// アカウント、メニュー予算変更ボタン非活性化
				setUpdateAvailability(true);
			} else {
				// 変更あり
				// 予算入力状態変更
				setIsDisabled(true);
				const workDiffAmount = calcMenuAmountTotal(rtbListAmount, menuAmount[0]);
				if (workDiffAmount >= 0) {
					// 予算変更ボタン活性化
					setUpdateAvailability(false);
					// 予算変更した配信種別名を取得する
					deliveryNames.current = "";
					rtbListAmount?.map((newAmount, index) => {
						if (newAmount !== oldAmountList[idx][index]) {
							if (deliveryNames.current !== "") {
								deliveryNames.current += ","
							}
							deliveryNames.current += optionsZeusDeliveryType[index].label
						}
						return null;
					});
					// 配信種別名セット
					setMenuNames(deliveryNames.current);
				} else {
					// 予算変更ボタン有効化
					setUpdateAvailability(true);
				}
			}
		}
	}, [rtbListAmount]);

	// Zeus配信種別毎の予算取得
	useEffect(() => {
		if (!accountBudget?.amounts) return;
		var flag = false;
		accountBudget?.amounts.map((amount) => {
			if (amount.message !== "") {
				flag = true;
			}
		});
		setZeusIsDisabledLocal(flag);
		accountBudget?.amounts.map((amount) => {
			if (amount.budgetNo === 10) {
				platformAccountId.current = amount.platformAccountId;
				const url = `${apollo_zeus_delivery_type_budgets_path}/${platformAccountId.current}/${budgetMonth1}`;
				ApolloAxios.get(url).then((response) => {
					setmsg({
						type: "loading",
						payload: {
							...data,
							loading: false,
						}
					});
					if (response.data.resultCode === 0) {
						var workRtbListAmount1:number[] = [0,0];
						var workRtbListAmount2:number[] = [0,0];
						var workRtbListAmountList:number[][] = [[0,0],[0,0]];
						var zeusBudgets:ZeusBudgets = response.data.result
						if (zeusBudgets.zeusBudgets) {
							zeusBudgets.zeusBudgets.map((zeusBudget, idx) => {
								optionsZeusDeliveryType.map((option) => {
									if (option.value === zeusBudget.deliveryType) {
										workRtbListAmount1[idx] = zeusBudget.budget;
										workRtbListAmount2[idx] = zeusBudget.nextBudget;
										// 配信種別名セット
										zeusBudget.deliveryTypeName = option.label;
									}
									return null
								})
								return null
							})
						} else {
							var zeusBudgetDetailList:ZeusBudgetDetail[] 
							const resultWork = optionsZeusDeliveryType.map((option) => {
								return {
									deliveryType: option.value,
									deliveryTypeName: option.label,
									budget: 0,
									nextBudget: 0,
								};
							})
							zeusBudgets.zeusBudgets = resultWork;
						}
						if (budgetMonth === budgetMonth1) {
							setRtbListAmount(workRtbListAmount1);
						} else {
							setRtbListAmount(workRtbListAmount2);
						}
						workRtbListAmountList[0] = workRtbListAmount1;
						workRtbListAmountList[1] = workRtbListAmount2;
						setOldAmountList(JSON.parse(JSON.stringify(workRtbListAmountList)));
						// 操作前データ保存
						beforeData.current = JSON.parse(JSON.stringify(zeusBudgets));
					} else {
						setmsg({
							type: "all",
							payload: {
								...data,
								open: true,
								type: "error",
								message: GetMessage("0",UI_BUDGET_EDIT,"E","12"),
								loading: false,
							}
						});
						// エラーの場合、予算を変更不可とする
						setRtbListDisabled(true);
					}
				}).catch(err => {
					// 認証期間切れ判定とエラーメッセージ表示
					if (!ApolloExpired(err, GetMessage("0",UI_BUDGET_EDIT,"E","12"), data, setmsg, history, setDrawerState, drawerState)) {
						// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
					}
					// エラーの場合、予算を変更不可とする
					setRtbListDisabled(true);
				});
			}
		})
	}, [accountBudget, reRead]);

	// 年月選択Effect
	useEffect(() => {
		if (!budgetMonth || !oldAmountList) return;
		var workAmount = JSON.parse(JSON.stringify(oldAmountList));
		var idx = 0;
		if (budgetMonth !== budgetMonth1) {
			idx = 1;
		}
		setRtbListAmount(workAmount[idx]);
		// 表示を初期化

	}, [budgetMonth]);

	// Zeus予算額Effect
	useEffect(() => {
		if (!menuAmount || !rtbListAmount) return;
		const workDiffAmount = calcMenuAmountTotal(rtbListAmount, menuAmount[0]);
		setDiffAmount(workDiffAmount);
	}, [menuAmount]);

	// 予算チェック
	const checkBudget = (zeusAccountDetail: ZeusAccountDetail) => {
		if (!rtbListAmount || !zeusAccountDetail) return;
		var lowerLimit = [[0,0],[0,0]]

		zeusAccountDetail.subBudgetLowerLimitCurrentMonth?.map((limit) =>{
			if (limit.deliveryType === 1) {
				lowerLimit[0][0] = limit.budgetLimit;
			} else if (limit.deliveryType === 2) {
				lowerLimit[0][1] = limit.budgetLimit;
			}
		})

		var idx = 0;
		if (budgetMonth !== budgetMonth1) {
			idx = 1;
		}
		var result = ""
		for (let i = 0; i < rtbListAmount.length; i++) {
			if (rtbListAmount[i] < lowerLimit[idx][i]) {
				if (result !== "") {
					result += "\r\n";	
				}
				result += "パフォーマンス広告 " + optionsZeusDeliveryType[i].label + "「当月の月予算を変更する場合は、" + lowerLimit[idx][i] + "円以上を設定してください。」";
			}
		}
		return result;
	}

	// Zeusアカウント情報取得
	const getAdAccount = () => {
		const url = `${zeus_ad_account}${platformAccountId.current}`;
		ApolloAxios.get(url).then((response) => {
			setmsg({
				type: "loading",
				payload: {
					...data,
					loading: false,
				}
			});
			// 予算下限値チェック（エラーメッセージも取得）
			const msg = checkBudget(response.data);
			if (msg === "") {
				// OK
				setCheckResult(!checkResult);
			} else {
				// NG
				setmsg({
					type: "all",
					payload: {
						...data,
						open: true,
						type: "error",
						message: msg ?? "配信種別の予算下限値エラーです",
						loading: false,
					}
				});
			}
		}).catch(err => {
			// 認証期間切れ判定とエラーメッセージ表示
			if (!ApolloExpired(err, GetMessage("0",UI_BUDGET_EDIT,"E","14"), data, setmsg, history, setDrawerState, drawerState)) {
				// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
			}
		});
	}

	// 予算更新Effect
	useEffect(() => {
		if (!changeAmount) return;
		accountBudget?.amounts.map((amount) => {
			if (amount.budgetNo === 10) {
				// 予算取得API呼び出し&予算下限値チェック
				getAdAccount();
			}
		})
		setChangeAmount(false);
	}, [changeAmount])

	// 予算更新Effect
	useEffect(() => {
		if (!checkResult) return;
		// 予算更新API呼び出し
		// 操作日時をセット
		logTime.current = moment().format("YYYY-MM-DD HH:mm:ss");
		// 操作ログ出力(更新)
		resultApi.current = 0;
		writeLog();
		var workBeforeData = JSON.parse(JSON.stringify(beforeData.current));
		var requestAmount:RequestZeusBudgets = {
			budget: menuAmount[0],
			zeusBudgets: workBeforeData.zeusBudgets,
		};
		if (rtbListAmount) {
			for (let i = 0; i < rtbListAmount.length; i++) {
				if (budgetMonth === budgetMonth1) {
					requestAmount.zeusBudgets[i].budget = rtbListAmount[i];
				} else {
					requestAmount.zeusBudgets[i].nextBudget = rtbListAmount[i];
				}
			}
		}
		// 月額予算更新
		const url = `${apollo_zeus_delivery_type_budgets_path}/${platformAccountId.current}/${budgetMonth}`;
		ApolloAxios.patch(url, requestAmount).then(response => {
			if (response.data.resultCode === 0) {
				// 操作ログ(成功)
				resultApi.current = 1;
				setmsg({
					type: "setMessage",
					payload: {
						...data,
						open: true,
						type: "success",
						message: GetMessage("0",UI_BUDGET_EDIT,"I","0"),
					}
				});
				// 予算入力状態初期化
				setIsDisabled(false);
				// 呼び出し元・再読み込み
				setRead(!read);
				setReRead(!reRead);
			} else {
				// 操作ログ(失敗)
				resultApi.current = 9;
				console.log(response.data.message);
				const errMsg = response.data.message ? response.data.message : GetMessage("0",UI_BUDGET_EDIT,"E","13");
				// エラーメッセージ表示
				setmsg({
					type: "setMessage",
					payload: {
						...data,
						open: true,
						type: "error",
						message: errMsg,
					}
				})
			}
		}).catch(err => {
			// 操作ログ(失敗)
			resultApi.current = 9;
			// 認証期間切れ判定とエラーメッセージ表示
			if (!ApolloExpired(err, GetMessage("0",UI_BUDGET_EDIT,"E","13"), data, setmsg, history, setDrawerState, drawerState)) {
				// 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
			}
		}).finally(() => {
			// 操作ログ出力(結果)
			writeLog();
			setCheckResult(false);
		})
	}, [checkResult])

	// 合計金額取得
	const getTotalAmount = (amountList: number[]) => {
		var total = 0;
		amountList.map((amount) => {
			total += amount;
			return null;
		});
		return total;
	};

	// 合計予算算出・差分算出セット
  const calcMenuAmountTotal = (amountList: number[], menuAmount: number) => {
		let total = getTotalAmount(amountList);
		// 差分算出
		let workAmount = menuAmount - total;
		setRegisterableAmount(workAmount);
		return workAmount
  };

	// 予算額リセットEffect
	useEffect(() => {
		if (!oldAmountList || !resetAmount) return;
		var workRtbListAmount:number[] = [0,0];
		var idx = 0;
		if (budgetMonth !== budgetMonth1) {
			idx = 1;			
		}
		workRtbListAmount = JSON.parse(JSON.stringify(oldAmountList[idx]));
		setRtbListAmount(workRtbListAmount);
		setResetAmount(false);
	}, [resetAmount])

	// 操作ログ出力
	const writeLog = () => {
		// 操作ログ出力を呼ばれるまでは処理しない
		if (resultApi.current < 0) return;
		// 項目リスト
		// 変更前予算金額
		const itemList1: ItemList[] = beforeData.current ? beforeData.current.zeusBudgets.map((zeusBudget:ZeusBudgetDetail) => {
			var budgetName = "";
			optionsZeusDeliveryType.map((option) => {
				if (option.value === zeusBudget.deliveryType) {
					budgetName = option.label;
				}
				return null
			})
			return {
				key: budgetName,
				beforeValue: budgetMonth === budgetMonth1 ? zeusBudget.budget + "" : zeusBudget.nextBudget ? zeusBudget.nextBudget + "" : "0",
				afterValue: "0",
			}
		}) : [];
		// 変更後予算金額
		var itemList2: ItemList[] = rtbListAmount ? rtbListAmount.map((zeusBudget:any, idx:number) => {
			var budgetName = "";
			optionsZeusDeliveryType.map((option, idx2) => {
				if (idx === idx2) {
					budgetName = option.label;
				}
				return null
			})
			return {
				key: budgetName,
				beforeValue: itemList1[idx].beforeValue + "",
				afterValue: zeusBudget ? zeusBudget + "" : "0",
			}
		}) : [];
		const itemList = itemList2;
		// 操作ログ
		const executionLog: LogData = {
			eventDate: logTime.current, // イベント日時 “YYYY-MM-DD HH:MM:SS“ 形式
			logType: resultApi.current === 0 ? "execute" : "result",// ログ種別 実行：execute, 結果：result
			result: resultApi.current === 0 ? "" : resultApi.current === 1 ? "成功" : "失敗",// 実行結果 成功 / 失敗 ※実行時は空文字
			userID: state.userprofile.userId,// ユーザID
			userName: state.userprofile.userName,// Apolloユーザ名 姓 + 半角スペース + ユーザ名
			accessToken: state.accesstoken, // APIアクセス用トークン
			accountGroupID: accountBudget ? accountBudget.accountgroupId : 0, // アカウントグループID
			accountGroupName: accountBudget ? accountBudget.accountgroupName : "", // アカウントグループ名
			accountID: accountBudget ? accountBudget.accountId : 0, // 広告主アカウントID
			accountName: accountBudget ? accountBudget.accountName : "", // 広告主アカウント名
			campaignID: "", // キャンペーンID
			campaignName: "", // キャンペーン名
			adGroupID: "", // 広告グループID
			adGroupName: "", // 広告グループ名
			menu: "パフォーマンス広告", // メニュー パフォーマンス広告 / メール広告 / ディスプレイ広告
			displayName: "予算設定画面", // 操作画面名称 〇〇画面
			category: "予算", // 操作対象 キャンペーン / セグメント etc...
			actionType: "更新", // アクション 参照 / 作成 / 更新 / 削除 / アップロード
			targetID: resultApi.current === 0 ? "" : budgetMonth === budgetMonth1 ? budgetMonth1 + "" : budgetMonth2 + "", // 操作を行うデータのID 実行時は空文字
			targetName: resultApi.current === 0 ? "" : "年月", // 操作を行うデータの名称 実行時は空文字
			itemList: itemList,
		}
		// 操作ログ出力
		ApolloEventRecord(executionLog);
	};

	return (
		<div>
			<Card className={classes.root} square variant="outlined">
				<CardContent style={{padding:10}}>
					<Grid item xs={12}>
						<Typography>
							{"パフォーマンス広告 キャンペーン種別別月額予算設定"}
						</Typography>
					</Grid>
				</CardContent>
			</Card>
			<Card className={classes.root} square variant="outlined">
				<CardContent style={{padding:10}}>
					{optionsZeusDeliveryType.map((data, index) => {
						return (
							<Fragment key={index}>
								<Grid spacing={0} container>
								<Grid item xs={12} md={11}>
									<ApolloTextNumberList propsTextList={propsTextNumberListZeusWork[index]}/>
								</Grid>
									<Grid item xs={12} md={1}>
										{"円"}
									</Grid>
								</Grid>
							</Fragment>
						)
					})}

					<Grid spacing={0} container>
						{/* 再計算 */}
						<Grid item xs={12} md={11}>
							{registerableAmount >= 0 ?
								<Typography variant="body1" color="textPrimary">
									{"あと " + registerableAmount.toLocaleString() + " 円 設定可能"}
								</Typography>
							:
								<Typography variant="body1" color="error">
									{(0 - registerableAmount).toLocaleString() + " 円 超過しています"}
								</Typography>
							}
						</Grid>
						<Grid item xs={12} md={1}>
						</Grid>
					</Grid>
				</CardContent>
			</Card>

		</div>
	)
}
